import { CheckCircle2, XCircle, PenLine, Ban, UserRound, CalendarClock, MessageCircle } from "lucide-react";

export const fmtDate = (s) => (s ? String(s).slice(0, 10).split("-").reverse().join("/") : "");

export const fmtDateTime = (s) => {
  if (!s) return "";
  const dt = new Date(s);
  return dt.toLocaleString("fr-FR", { day: "2-digit", month: "2-digit", year: "numeric", hour: "2-digit", minute: "2-digit" });
};

export const isoOffset = (days) => {
  const d = new Date();
  d.setDate(d.getDate() + days);
  return d.toISOString().slice(0, 10);
};

export const DOC_TYPES = [
  { value: "pmt", label: "PMT" },
  { value: "bulletin", label: "BS — Bulletin de situation" },
  { value: "pmt_request", label: "Demander une PMT" },
  { value: "autre", label: "Autre document" },
];
export const DOC_TYPE_LABEL = { pmt: "PMT", bulletin: "BS", pmt_request: "PMT À DEMANDER", autre: "Document" };
export const DOC_TYPE_LONG = { pmt: "PMT — Prescription médicale de transport", bulletin: "BS — Bulletin de situation", pmt_request: "PMT À DEMANDER — au secrétariat / service", autre: "Autre document" };
export const DOC_TYPE_CLS = { pmt: "bg-brand-800 text-white", bulletin: "bg-violet-600 text-white", pmt_request: "bg-orange-600 text-white", autre: "bg-slate-600 text-white" };

export const STATUS = {
  a_recuperer: { label: "À récupérer", cls: "bg-accent-50 text-accent-800 border-accent-200", dot: "bg-accent-500" },
  pris_en_charge: { label: "À récupérer", cls: "bg-accent-50 text-accent-800 border-accent-200", dot: "bg-accent-500", assigned: true },
  en_attente: { label: "En attente d'une date", cls: "bg-orange-50 text-orange-700 border-orange-200", dot: "bg-orange-500" },
  recupere: { label: "Récupéré", cls: "bg-green-50 text-green-700 border-green-200", dot: "bg-green-500" },
};

export const PRIORITY = {
  urgent: { label: "Urgent", cls: "bg-red-50 text-red-700 border-red-200" },
  soon: { label: "Échéance proche", cls: "bg-orange-50 text-orange-700 border-orange-200" },
  waiting: { label: "En attente", cls: "bg-slate-100 text-slate-600 border-slate-200" },
  normal: { label: "Normal", cls: "bg-accent-50 text-accent-800 border-accent-200" },
  done: { label: "Terminé", cls: "bg-green-50 text-green-700 border-green-200" },
};

// Actions chauffeur par type de document (miroir de DOCUMENT_WORKFLOWS backend : type → actions → clôture → points).
const ICONS = { pmt_ok: CheckCircle2, bs_ok: CheckCircle2, doc_ok: CheckCircle2, pmt_non_realisee: XCircle, bs_non_disponible: XCircle, doc_non_disponible: XCircle, pmt_non_disponible: XCircle,
  pmt_non_signee: PenLine, refus: Ban, refus_remise: Ban, a_demander: UserRound, revenir_plus_tard: CalendarClock, autre: MessageCircle };
export const FEEDBACK_OPTIONS = [
  { result: "pmt_ok", icon: CheckCircle2, label: "PMT récupérée / OK", color: "green", extra: null },
  { result: "pmt_non_realisee", icon: XCircle, label: "PMT pas réalisée", color: "red", extra: "date" },
  { result: "pmt_non_signee", icon: PenLine, label: "PMT non signée", color: "amber", extra: "date" },
  { result: "refus", icon: Ban, label: "Refus de faire", color: "red", extra: "comment" },
  { result: "a_demander", icon: UserRound, label: "À demander à…", color: "blue", extra: "contact" },
  { result: "revenir_plus_tard", icon: CalendarClock, label: "Revenir plus tard", color: "amber", extra: "date" },
  { result: "autre", icon: MessageCircle, label: "Autre", color: "blue", extra: "comment" },
];
export const feedbackOptionsFor = (workflows, docType) => {
  const wf = workflows?.[docType] || workflows?.autre;
  if (!wf) return FEEDBACK_OPTIONS;
  return wf.actions.map((a) => ({ ...a, icon: ICONS[a.result] || MessageCircle }));
};

export const DATE_SHORTCUTS = [
  { label: "Aujourd'hui", days: 0 },
  { label: "Demain", days: 1 },
  { label: "+2 jours", days: 2 },
  { label: "+7 jours", days: 7 },
];

export const ROLE_LABEL = {
  chauffeur: "Chauffeur",
  regulation: "Régulateur",
  admin: "Administrateur",
  administratif: "Personnel administratif",
  superadmin: "Super Admin",
};
